import React from 'react'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { settings } from '../../pages/client/client-tour/settings'
import useClientTour from '../../hooks/useClientTour'

const NestedRouteOutlet = () => {
  const user = useSelector((state) => state?.user)
  const tour = useSelector((state) => state?.tour)

  useClientTour({
    enabled: !user?.has_seen_tour && !tour?.settings_page && user?.is_client,
    steps: settings,
    tourKey: 'settings_page',
    nextRoute: '/client/programs',
    skipRoute: '/client/settings',
  })

  return (
    <div className=''>
      <Outlet />
    </div>
  )
}

export default NestedRouteOutlet
